import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/svg/payments/background.svg'
import _imports_1 from '@/assets/svg/payments/background-s.svg'
import _imports_2 from '@/assets/svg/payments/screenshots.svg'


const _hoisted_1 = { class: "d-flex justify-content-center position-relative" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-payments-background",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-payments-background-s",
  src: _imports_1
}, null, -1)
const _hoisted_4 = { class: "payments-content d-flex flex-column align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "caps-text mx-4" }, "Начните принимать платежи с VDCloud", -1)
const _hoisted_6 = { class: "container-m-l" }
const _hoisted_7 = { class: "d-flex mt-4" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("(function(w,d,u){ var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://b24.vti-service.ru/upload/crm/form/loader_24_x5yssp.js');")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Подключить")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Личный кабинет")
const _hoisted_11 = { class: "d-flex mt-4" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("(function(w,d,u){ var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);})(window,document,'https://b24.vti-service.ru/upload/crm/form/loader_24_x5yssp.js');")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Подключить")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Личный кабинет")
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  class: "img-payments-screenshots",
  src: _imports_2
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
              "data-b24-form": "click/24/x5yssp",
              "data-skip-moving": "true"
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })),
            _createVNode(_component_Button, {
              class: "me-3",
              size: "large",
              style: {"width":"280px"}
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              size: "large",
              style: {"width":"280px"},
              onClick: _ctx.openLK
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(), _createBlock(_resolveDynamicComponent('script'), {
            "data-b24-form": "click/24/x5yssp",
            "data-skip-moving": "true"
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })),
          _createVNode(_component_Button, {
            class: "me-2 container-s",
            size: "mini"
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_Button, {
            class: "container-s",
            size: "mini",
            onClick: _ctx.openLK
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _hoisted_15
      ])
    ]),
    _createVNode(_component_Footer)
  ], 64))
}